@if ("FOLDER.PLACEHOLDER.DATE" | translate; as placeholder) {
    <p-inputMask
        [formControl]="dateStringControl"
        mask="99-99-9999"
        [placeholder]="placeholder"
        [slotChar]="placeholder"
        (onComplete)="onComplete()"
        [autoFocus]="autoFocus"
    >
    </p-inputMask>
}
